import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

const YAPI = false

export const getRecommendList = async (params: object) => {
  return await GET({
    url: YAPI ? 'http://yapi.bingex.com/mock/1082/activityCenter/inviteCourierActivity/findInviteUserPage'
      : '/activityCenter/inviteCourierActivity/findInviteUserPage',
    params,
    showError: false
  })
}
